var map = {
	"./news.js": "G61+",
	"./ourServices.js": "r8V3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CvEH";


//////////////////
// WEBPACK FOOTER
// ./src/store/module nonrecursive \.js$
// module id = CvEH
// module chunks = 52